export const ConfigProd = {
    // baseUrl: 'https://prod-dgc-app.azurewebsites.net/',
    // vechainBaseUrl: 'https://explore.vechain.org/transactions/'
    baseUrl: process.env.REACT_APP_BASE_URL,
    vechainBaseUrl: process.env.REACT_APP_VECHAIN_URL
};
